<script>
import { mapState } from 'vuex';

export default {
  name: 'LimitNum',
  data () {
    return {
      isShowDialog: false
    };
  },
  computed: {
    ...mapState('publicStore', ['isShowLimitNum'])
  },
  watch: {
    isShowLimitNum: {
      handler (val) {
        this.isShowDialog = val;
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations('publicStore', ['setIsShowLimitNum', 'setIsShowAppDownload']),
    closePopup (name) {
      this.setIsShowLimitNum(false);
      if (name === 'app') {
        this.setIsShowAppDownload(true);
      }
    }
  }
};
</script>

<template>
  <md-popup
    v-model="isShowDialog"
    :position="'center'"
    :mask-closable="true"
    class="limit-num-popup"
    :has-mask="true">
    <div class="limit-num-box">
      <div class="limit-num-content">
        <div class="limit-num-text">
          观看提示
        </div>
        <div class="limit-num-center">
          <div class="center-text-top">
            您今日免费观看次数已用完
          </div>
          <div class="center-text-app">
            下载APP即可解锁更多特权
          </div>
        </div>
        <div class="limit-num-footer">
          <div class="footer-btn-1" @click="closePopup('close')">
            我在想想
          </div>
          <div class="footer-btn-2" @click="closePopup('app')">
            下载APP
          </div>
        </div>
      </div>
    </div>
  </md-popup>
</template>

<style scoped lang="scss">
.limit-num-popup {
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.limit-num-box {
  background: url('./assets/bg.png');
  background-size: 100% 100%;
  width: 304px;
  height: 406px;
  position: relative;
  overflow: hidden;
  .limit-num-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: -100px;
    left: 0;
    padding: 0 20px;
  }
  .limit-num-text {
    font-family: YouSheBiaoTiHei;
    font-weight: 400;
    font-size: 36px;
    line-height: 100%;
    letter-spacing: -0.76px;
    text-align: center;
    color: #00948A;
  }
  .limit-num-center {
    width: 100%;
    height: auto;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .center-text-top {
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 14px;
      line-height: 22px;
      text-align: center;
      color: #333;
      ;
    }
    .center-text-app {
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 14px;
      line-height: 22px;
      text-align: center;
      color: #32B8AF;
    }
  }
  .limit-num-footer {
    width: 100%;
    height: 40px;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    .footer-btn-1 {
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 14px;
      line-height: 22px;
      text-align: center;
      color: #32B8AF;
      background-color: #fff;
      border: 1px solid #32B8AF;
      padding: 8px 20px;
      border-radius: 5px;
      flex: 1;
    }
    .footer-btn-2 {
      flex: 1;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 14px;
      line-height: 22px;
      text-align: center;
      color: #FFFFFF;
      background-color: #32B8AF;
      border: 1px solid #32B8AF;
      padding: 8px 20px;
      border-radius: 5px;
    }
  }
}
</style>
